import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useStyles } from 'uinix-ui';

import AuthenticationStore from '~/auth/authenticationStore';
import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Logo } from '~/eds/src/components/Logo/Logo';
import { Text } from '~/eds/src/components/Text/Text';
import { LOGIN_CONSTANTS } from '~/features/login/constants';
import { useRouting } from '~/routing/useRouting';
import { getClientFromUrl } from '~/routing/utils';

const Page = () => {
  const AS = AuthenticationStore();
  const intl = useIntl();

  const client = getClientFromUrl();

  const { getSearchParam, navigate } = useRouting();

  const styles = useStyles();

  // redirect if user is already logged in
  useEffect(() => {
    const isSessionExpired = AS.isAuthSessionExpired();
    const isInactiveTimeout = AS.isInactiveTimeoutReached();
    const isUserLoggedIn = AS.isLoggedIn();
    const isUserLoggedOut =
      isSessionExpired || isInactiveTimeout || !isUserLoggedIn;

    if (!isUserLoggedOut) {
      navigate(
        getSearchParam(LOGIN_CONSTANTS.SEARCH_PARAMS.LOGIN_REDIRECT_TO, '/'),
      );
    }
  }, []);

  const handleEmbedLogin = () => {
    const newUrl = new URL(window.location.href);
    const params = new URLSearchParams(newUrl.search);

    newUrl.pathname = `${client}/login`;
    newUrl.search = params.toString();

    window.open(newUrl.href, '_blank', 'width=480,height=700,left=200,top=200');
  };

  return (
    <Layout
      align="center"
      justify="center"
      styles={styles.background.darkChrome}
    >
      <Layout align="center" preset="sections">
        <Logo mode="icon" theme="dark" />
        <Text color="inherit" textAlign="center" variant="title">
          {intl.formatMessage({
            id: 'LoginEmbedPage.workspaceLoginTitle',
            defaultMessage: 'Log in to your workspace',
            description: 'Title text for embedded login page',
          })}
        </Text>
        <Button
          isFullWidth
          text={intl.formatMessage({
            id: 'LoginEmbedPage.loginButton',
            defaultMessage: 'Log in',
            description: 'Login button text',
          })}
          variant="primary"
          onClick={handleEmbedLogin}
        />
      </Layout>
    </Layout>
  );
};

export default Page;
